import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import styles from './Mask.less'

const Mask = React.memo(({ transparent = false, className, ...others }) => {
    const maskRef = useRef(null)
    const bodyScroll = function (e) {
        e.preventDefault()
    }
    useEffect(() => {
        maskRef.current.addEventListener('touchmove', bodyScroll, { passive: false })
        return () => {
            maskRef.current.removeEventListener('touchmove', bodyScroll, { passive: false })
        }
    }, [])
    const cls = classNames(styles['mask'], className)
    return <div className={cls} {...others} ref={maskRef} />
}, () => true)

export default Mask
